if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
        this.handleResize = this.handleResize.bind(this);
      }
      connectedCallback() {
        // Only run if data-enable-slider is true
        if (this.dataset.enableSlider !== 'true') return;
        // Cache DOM elements
        this.sliderContainer = this.querySelector('.swiper');
        this.sliderWrapper = this.querySelector('.swiper-wrapper');
        this.nextButton = this.querySelector('.swiper-btn-next');
        this.prevButton = this.querySelector('.swiper-btn-prev');
        this.pagination = this.querySelector('.swiper-pagination');
        this.slideCountElement = this.querySelector('.swiper-slide-count');
        if (!this.sliderContainer || !this.sliderWrapper) {
          console.error('Swiper container or wrapper not found!');
          return;
        }
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.destroySlider();
      }
      handleResize() {
        const destroyOnMobile = this.dataset.destroyMobile === 'true';
        const isMobile = window.innerWidth <= 767;
        if (destroyOnMobile && isMobile) {
          this.destroySlider();
        } else if (!this.swiperInstance) {
          this.initSlider();
        }
      }
      destroySlider() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }
      initSlider() {
        const items = parseFloat(this.dataset.items || '1');
        const itemsMobile = parseFloat(this.dataset.itemsMobile || '1');
        const autoPlay = this.dataset.autoPlay === 'true';
        const loop = this.dataset.loop === 'true';
        const speed = parseFloat(this.dataset.speed || '3000');
        const spaceBetween = parseFloat(this.dataset.spaceBetween || '16');
        const spaceBetweenMobile = parseFloat(this.dataset.spaceBetweenMobile || '12');
        const config = {
          slidesPerView: items,
          spaceBetween,
          loop,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          pagination: {
            el: this.pagination,
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          breakpoints: {
            320: { slidesPerView: itemsMobile, spaceBetween: spaceBetweenMobile },
            1024: { slidesPerView: items, spaceBetween },
          },
          on: {
            afterInit: () => setTimeout(() => this.updateSlideCount(), 100),
            slideChange: () => this.updateSlideCount(),
          },
        };
        if (autoPlay) {
          config.autoplay = { delay: speed, disableOnInteraction: false };
        }
        this.swiperInstance = new Swiper(this.sliderContainer, config);
        setTimeout(() => this.updateSlideCount(), 150);
      }
      updateSlideCount() {
        if (!this.swiperInstance || !this.slideCountElement) return;
        const current = this.swiperInstance.realIndex + 1;
        const totalSlides =
          this.swiperInstance.slides.length -
          (this.swiperInstance.loopedSlides || 0) * 2;
        this.slideCountElement.textContent = `${current} / ${totalSlides - 1}`;
      }
    }
  );
}
if (!customElements.get('mobile-slider-component')) {
  customElements.define(
    'mobile-slider-component',
    class MobileSliderComponent extends HTMLElement {
      connectedCallback() {
        if (window.innerWidth > 767 || this.dataset.enableSlider !== 'true') return;

        this.sliderContainer = this.querySelector('.swiper');
        this.sliderWrapper = this.querySelector('.swiper-wrapper');
        this.nextButton = this.querySelector('.swiper-btn-next');
        this.prevButton = this.querySelector('.swiper-btn-prev');
        this.pagination = this.querySelector('.swiper-pagination');
        if (!this.sliderContainer || !this.sliderWrapper) {
          console.error('Mobile swiper container or wrapper not found!');
          return;
        }
        this.initMobileSlider();
      }
      initMobileSlider() {
        const itemsMobile = parseFloat(this.dataset.itemsMobile || '1');
        const config = {
          slidesPerView: itemsMobile,
          spaceBetween: 12,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          pagination: {
            el: this.pagination,
            clickable: true,
          },
        };
        this.mobileSwiper = new Swiper(this.sliderContainer, config);
      }
    }
  );
}
